import { useCallback, useEffect, useState } from 'react';
import { DataSoldOrders, FetchSoldProductsSearchProps, ListSoldOrders } from 'lib/models/listSoldProducts';

function useListSoldOrders(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [orders, setOrders] = useState<DataSoldOrders>({} as DataSoldOrders);

	const refetch = useCallback(
		async (props?: FetchSoldProductsSearchProps) => {
			setLoading(true);
			const response = await ListSoldOrders(props || searchProps);
			setOrders(response);
			setLoading(false);
		},
		[searchProps]
	);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, orders, refetch, setLoading };
}

export default useListSoldOrders;
